import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import Dashboard from "./components/Dashboard";
// import Tenders from "./components/Tenders";
import "./App.css";
import Home from "./components/dashboard/Home";
import Tenders from "./components/Tenders";
import Sidebar from "./components/dashboard/Sidebar";
import Dash from "./components/Dash";
import TempleTiming from "./components/TempleTiming";
import SpstTiming from "./components/SpstTiming";
import DisplayTiming from "./components/DisplayTiming";
import Notices from "./components/Notices";
import NoticesDisplay from "./components/NoticesDisplay";
import Layout from "./components/Layout";
import Photo from "./components/Photo";
import TempleTimingsTable from "./components/TempleTimingsTable";
import DarsanTime from "./components/DarsanTime";
import GalleryView from "./components/GalleryView";
import Updates from "./components/Updates";
import Newprofile from "./components/Newprofile";
import PrintPage from "./PrintPage";
import Searchprofile from "./components/Searchprofile"
import SearchDate from "./components/SearchDate";
import AdvancedSearch from "./components/AdvancedSearch";
import CollectionReport from "./components/CollectionReport"
import MalayalamCalendar from "./components/MalayalamCalendar";
import Visiting from "./components/Visiting";
import General from "./components/General";
import Malayalam from "./components/Malayalam";

function App() {
  const [isOpen, setIsOpen] = useState(true);

  return (

    <Router>
      <div className="app-container">

        {/* Main Content */}
        <div className={`content ${isOpen ? "shifted" : ""}`}>
          <Routes>
            <Route path="/" element={<Navigate to="/Login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/tenders" element={<Tenders />} />
            <Route path="/templetiming" element={<TempleTiming />} />
            <Route path="/spsttiming" element={<SpstTiming />} />
            <Route path="/displaytiming" element={<DisplayTiming />} />
            <Route path="/notices" element={<Notices />} />
            <Route path="/noticesdisplay" element={<NoticesDisplay />} />
            <Route path="/layout" element={<Layout />} />
            <Route path="/photo" element={<Photo />} />
            <Route path="/TempleTimingsTable" element={<TempleTimingsTable />} />
            <Route path="/darsantime" element={<DarsanTime />} />
            <Route path="/galleryview" element={<GalleryView />} />
            <Route path="/updates" element={<Updates />} />
            <Route path="/newprofile" element={<Newprofile />} />
            <Route path="/print" element={<PrintPage />} />
            <Route path="/searchprofile" element={<Searchprofile />} />
            <Route path="/searchdate" element={<SearchDate />} />
            <Route path="/advancedsearch" element={<AdvancedSearch />} />
            <Route path="/collectionreport" element={<CollectionReport />} />
            <Route path="/malayalamcalendar" element={<MalayalamCalendar />} />
            <Route path="/visiting" element={<Visiting />} />
            <Route path="/general" element={<General />} />
            <Route path="/malayalam" element={<Malayalam />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;